import { Controller } from '@hotwired/stimulus'
import { toggleVisibility } from "utils/toggle_element_visibility"

export default class extends Controller {
  static targets = ["finishButton", "checkbox", "other"]

  initialize() {
    // In case users use BFCache and Finish button is disabled
    window.addEventListener("load", () => {
      this._toggleFinishButton()
    })
  }

  check(event) {
    if (event.target.value === "0") {
      toggleVisibility(this.otherTarget, event.target.checked)
    }

    this._toggleFinishButton()
  }

  textInput(_event) {
    this._toggleFinishButton()
  }

  _toggleFinishButton() {
    // At least 1 check box.
    // At most 2 check boxes.
    // If other checkbox is filled, a reason must be given.
    let checkCounter = 0
    let otherRequired = false

    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.checked) {
        checkCounter++

        if (checkbox.value === "0") {
          otherRequired = true
        }
      }
    })

    // Completed case
    if (checkCounter > 0 && checkCounter < 3 && this._checkOtherRequired(otherRequired)) {
      this.finishButtonTarget.removeAttribute("disabled")
    } else {
      this.finishButtonTarget.setAttribute("disabled", true)
    }
  }

  _checkOtherRequired(otherRequired) {
    return !otherRequired || this.otherTarget.value.length > 0
  }
}
